import { render, staticRenderFns } from "./ParentOrderCard.vue?vue&type=template&id=4bfb0eab"
import script from "./ParentOrderCard.vue?vue&type=script&lang=ts"
export * from "./ParentOrderCard.vue?vue&type=script&lang=ts"
import style0 from "./ParentOrderCard.vue?vue&type=style&index=0&id=4bfb0eab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports